import { formatters } from '@app/ui';
import { InactiveBadge } from './InactiveBadge';
import classNames from 'classnames';

export type NameValue = {
  firstName: string;
  lastName: string;
  active?: boolean;
  status?: 'INACTIVE' | string;
};

export interface NameProps {
  value: NameValue;
  className?: string;
}

export function Name(props: NameProps) {
  const { value, className } = props;
  const inactive = value.active === false || value.status === 'INACTIVE';

  return (
    <span className={classNames(className, 'Name', { 'line-through': inactive })}>
      {formatters.name(value)}
      {inactive && <InactiveBadge className="ms-2" />}
    </span>
  );
}
